import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

export default class ColorSelectionButton extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, colorValues)
    {
        super(scene);

        this.colorValues = colorValues;

        this.bgOutline = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_COLORS_paint_swatch_outline, this);
        this.colorCircle = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_COLORS_paint_swatch, this).setTint(Phaser.Display.Color.HexStringToColor(this.colorValues.light).color);

        let bounds = this.getBounds();
        this.setSize(bounds.width, bounds.height).setInteractive();
    }
}